(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var modal=document.getElementById('oncoyou-notice');
    if(!modal) return;

    // garante que o aviso apareça em toda navegação
    modal.classList.remove('oncoyou-hidden');

    var btn=document.getElementById('oncoyou-continue');
    if(btn){
      btn.addEventListener('click',function(){
        // fecha apenas nesta página; reaparece no próximo carregamento
        modal.classList.add('oncoyou-hidden');
      });
    }

    // permite fechar com ESC; reaparece no próximo carregamento
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){ modal.classList.add('oncoyou-hidden'); }
    });
  });
})();
